import React from "react";
import { ArrowLeft, Circle } from "lucide-react";
import { Link } from "react-router-dom";

const Product_Infomation = () => {
  return (
    <>
      {/* TOP PRODUCT SECTION */}
      <section>
        <div className="py-6 md:py-10 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            
            {/* Back Button */}
          <Link to={'/'}>
            <button className="flex items-center gap-2 bg-green-900 text-white px-6 py-2 rounded-lg mb-6 hover:bg-[#0D542B] transition">
              <ArrowLeft size={18} />
              BACK
            </button>
          </Link>
<div className="grid md:grid-cols-2 gap-6 items-stretch">
  
  {/* Image */}
  <div className="bg-[#FCFDF8] rounded-xl flex justify-center items-center h-full">
    <img
      src="https://nutralike.com/wp-content/uploads/2025/10/Gemini_Generated_Image_gv0182gv0182gv01-scaled.png"
      alt="Product"
      className="max-h-[400px] object-cover"
    />
  </div>

  {/* Content */}
  <div className="bg-[#F2F6EF] rounded-xl p-8 shadow-sm h-full flex flex-col justify-between">
    
    <div>
      <h2 className="text-2xl md:text-3xl font-bold text-green-900 mb-6">
        GLUTATHIONE EFFERVESCENT <br /> TABLET
      </h2>

      {/* Benefits */}
      <div className="mb-10">
        <span className="bg-gray-300 text-green-900 text-sm font-semibold px-4 py-1 rounded">
          BENEFITS:
        </span>

        <ul className="mt-4 space-y-3 text-gray-700">
          <li className="flex gap-3">
            <Circle size={12} className="fill-[#0D542B] mt-2" />
            Boosts the body's antioxidant defenses with Glutathione and Vitamin C
          </li>
          <li className="flex gap-3">
            <Circle size={12} className="fill-[#0D542B] mt-2" />
            Helps maintain youthful, radiant skin
          </li>
        </ul>
      </div>

      {/* Categories */}
      <div className="mb-10">
        <span className="bg-gray-300 text-green-900 text-sm font-semibold px-4 py-1 rounded">
          CATEGORIES:
        </span>

        <div className="flex gap-3 mt-4 text-gray-700">
          <Circle size={12} className="fill-[#0D542B] mt-2" />
          Effervescent Tablets, Products, Skin Care Supplements
        </div>
      </div>
    </div>

    <button className="bg-green-900 text-white px-6 py-3 rounded-lg hover:bg-[#0D542B] transition">
      INQUIRE NOW
    </button>
  </div>
</div>
          </div>
        </div>
      </section>

      {/* DESCRIPTION SECTION */}
      <section className="bg-[#F2F6EF] py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">

          {/* Title */}
          <h2 className="text-xl md:text-2xl font-semibold text-green-900 flex items-center gap-3 mb-10">
            <img src="https://nutralike.com/wp-content/uploads/2025/10/Private-Label-Nutalike.svg" alt="" />
            DISCRIPTION
          </h2>

          {/* Grid */}
          <div className="grid md:grid-cols-2 gap-10 relative">
            
            {/* Divider Line */}
            <div className="hidden md:block absolute left-1/2 top-0 h-full w-[1px] bg-[#0D542B]"></div>

            {/* LEFT SIDE */}
            <div className="space-y-12">
              
              {/* Block */}
              <div>
                <span className="bg-gray-300 px-4 py-2 text-green-900 font-semibold text-sm">
                  KEY INGREDIENTS:
                </span>

                <div className="flex gap-3 mt-4 text-gray-700">
                  <Circle size={12} className="fill-[#0D542B] mt-2" />
                  Glutathione, Vitamin C and N-Acetyl L-Cysteine
                </div>
              </div>

              <div>
                <span className="bg-gray-300 px-4 py-2 text-green-900 font-semibold text-sm">
                  FLAVOUR AVAILABLE:
                </span>

                <div className="flex gap-3 mt-4 text-gray-700">
                  <Circle size={12} className="fill-[#0D542B] mt-2" />
                  Orange, Lemon, Watermelon, Strawberry (Customize as per your requirement)
                </div>
              </div>

              <div>
                <span className="bg-gray-300 px-4 py-2 text-green-900 font-semibold text-sm">
                  AVAILABLE PACKING MATERIAL:
                </span>

                <div className="flex gap-3 mt-4 text-gray-700">
                  <Circle size={12} className="fill-[#0D542B] mt-2" />
                  Tube pack
                </div>
              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="space-y-12">
              
              <div>
                <span className="bg-gray-300 px-4 py-2 text-green-900 font-semibold text-sm">
                  PACKING SIZE:
                </span>

                <div className="flex gap-3 mt-4 text-gray-700">
                  <Circle size={12} className="fill-[#0D542B] mt-2" />
                  3 Tab, 10 Tab, 15 Tab, 20 Tab
                </div>
              </div>

              <div>
                <span className="bg-gray-300 px-4 py-2 text-green-900 font-semibold text-sm">
                  SHELF LIFE:
                </span>

                <div className="flex gap-3 mt-4 text-gray-700">
                  <Circle size={12} className="fill-[#0D542B] mt-2" />
                  18 Months
                </div>
              </div>

              <div>
                <span className="bg-gray-300 px-4 py-2 text-green-900 font-semibold text-sm">
                  MINIMUM ORDER QUANTITY:
                </span>

                <div className="flex gap-3 mt-4 text-gray-700">
                  <Circle size={12} className="fill-[#0D542B] mt-2" />
                  2000 Tube
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* RELATED PRODUCTS CARDS */}
<section className=" py-12">
  <div className="max-w-7xl mx-auto px-4 sm:px-6">

    {/* Title */}
    <div className="text-center mb-10">
      <img
        src="https://nutralike.com/wp-content/uploads/2025/10/Private-Label-Nutalike.svg"
        alt="logo"
        className="w-10 mx-auto mb-3"
      />
      <h2 className="text-2xl md:text-3xl font-semibold tracking-wide text-[#0D542B]">
        RELATED PRODUCTS
      </h2>
    </div>

    {/* Cards Grid */}
    <div className="grid md:grid-cols-3 gap-6">

      {/* Card 1 */}
      <div className="bg-white rounded-xl overflow-hidden border border-gray-300 hover:shadow-md transition">
        
        <div className="flex justify-center items-center ">
          <img
            src="https://nutralike.com/wp-content/uploads/2025/10/Gemini_Generated_Image_gv0182gv0182gv01-scaled.png"
            alt="product"
            className="h-[450px] object-cover"
          />
        </div>

        <div className="bg-[#dfe6df] text-center py-4 px-2">
          <p className="text-[#0D542B] font-medium tracking-wide text-sm">
            ACV EFFERVESCENT TABLET
          </p>
        </div>
      </div>

      {/* Card 2 */}
      <div className="bg-white rounded-xl overflow-hidden border border-gray-300 hover:shadow-md transition">
        
        <div className="flex justify-center items-center ">
          <img
            src="https://nutralike.com/wp-content/uploads/2025/10/Gemini_Generated_Image_gv0182gv0182gv01-scaled.png"
            alt="product"
            className="h-[450px] object-cover"
          />
        </div>

        <div className="bg-[#dfe6df] text-center py-4 px-2">
          <p className="text-[#0D542B] font-medium tracking-wide text-sm truncate">
            COLLAGEN PEPTIDE EFFERVESCENT TABLET
          </p>
        </div>
      </div>

      {/* Card 3 */}
      <div className="bg-white rounded-xl overflow-hidden border border-gray-300 hover:shadow-md transition">
        
        <div className="flex justify-center items-center ">
          <img
            src="https://nutralike.com/wp-content/uploads/2025/10/Gemini_Generated_Image_gv0182gv0182gv01-scaled.png"
            alt="product"
            className="h-[450px] object-cover"
          />
        </div>

        <div className="bg-[#dfe6df] text-center py-4 px-2">
          <p className="text-[#0D542B] font-medium tracking-wide text-sm">
            VITAMIN C EFFERVESCENT TABLET
          </p>
        </div>
      </div>

    </div>
  </div>
</section>
    </>
  );
};

export default Product_Infomation;